import { TranslateService } from '@ngx-translate/core';
import { Model } from '../../api/model';
import { Translatable } from '../../localization/translatable';
import { DefaultElements } from '../config/elements';

export class FieldMeta extends Model {
    public id;
    public uuid;
    public name;
    public type;
    public dynamic;
    public validation;
    public config: FieldMetaConfig = {};
    public settings                = {};

    protected identifier = 'name';

    protected _label;

    public constructor(data: Object = {}, service = null) {
        super(data, service);
        this.boot(data);

        const element = DefaultElements.find(el => {
            return el.type === this.type;
        });

        if (element && element.settings) {
            this.settings = element.settings;
        }
    }

    public get label() {
        return this._label;
    }

    public set label(label) {
        this._label = new Translatable(label, this._service.injector.get(TranslateService));
    }
}

export interface FieldMetaConfig {
    available_in_overview?: boolean;
    show_in_overview?: boolean;
    extra_information?: string;
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/entities/models/field-meta.model.ts